import { Form, Formik } from 'formik';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAssessmentName, selectSkipContent } from 'reducers/assessment';
import { closeModal } from 'reducers/modal';
import { Button } from 'components/button/Button';

type ModalProps = {
  data: {
    title: string;
    info: string;
  };
};

export const AbilityTestsTxtModal: React.FC<ModalProps> = ({ data }) => {
  const abilityTxtModal = useRef<HTMLInputElement>(null);

  const dispatch = useDispatch();
  const skipContentSet = useSelector(selectSkipContent);

  const triggerNextFocus = () => {
    const assessmentContainer: any = document.getElementsByClassName("AssessmentOuter")[0];
    if(assessmentContainer){
      const allFocusEleArr: any = assessmentContainer.querySelectorAll('a, button, input, textarea, select, details, [tabindex]');
      allFocusEleArr[0].focus();
    }
  };    

  useEffect(() => {
    abilityTxtModal.current?.focus();
  }, [abilityTxtModal]);    

  const handleCloseModal = () => {
    if(skipContentSet){
      triggerNextFocus();
    } else {
      const skipContentBtn = document.getElementsByClassName("SkipContentBtn")[0] as HTMLElement;
      const accessibilityBtn = document.getElementsByClassName("AccessibilityBtn")[0] as HTMLElement;
      if(skipContentBtn){
        skipContentBtn.focus();
      } else if(accessibilityBtn){
        accessibilityBtn.focus();
      }
    }

    dispatch(closeModal());
  };
  
  const modalStyle = {
    '--modalTitleColor': '#036C8F',
    '--footerBackgroundColor': '#f5f5f5',
    '--footerBorderColor': '#f5f5f5',
    '--primaryButtonBackgroundColor': '#36705B',
    '--tertiaryButtonBackgroundColor': '#d5d5d5',
  } as React.CSSProperties;

  const assessmentName = useSelector(selectAssessmentName);

  const currentWebskin = window.sessionStorage.getItem('webskin')
    ? window.sessionStorage.getItem('webskin')
    : 'defaultTheme';   

  let _safariStr = navigator.userAgent.toLowerCase();
  let _safari = ((_safariStr.indexOf("safari") !== -1) && (_safariStr.indexOf("chrome") === -1)) ? true : false; 

  return (
    <div className={"AbilityTestsBeforeYouBeginModal" + 
      (_safari ? " AltModal" : "") + 
      (assessmentName ? (' ' + assessmentName) : '') + 
      (currentWebskin !== 'defaultTheme' ? (' ' + currentWebskin) : '')
    } 
      style={modalStyle}
    >
      <Formik initialValues={{}} onSubmit={() => {}}>
        <Form>
          <div className="AbilityTestsBeforeYouBeginModal__content AbilityTestsModalContent">
            <div 
              className="AbilityTestsBeforeYouBeginModal__message"
              ref={abilityTxtModal}
              tabIndex={0}                
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: data.info,
                }}
              />            
            </div>
          </div>
          <div className="ModalFooter">
            <Button
              className="Rounded"
              priority="tertiary"
              type="button"
              onClick={handleCloseModal}
            >
              Close
            </Button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};
